module.exports = __webpack_public_path__ + "static/cosmicguard.com/img/servers_header.bc80df74.png";